import React from 'react';
import './ssd.css';
import { Button, NumericInput } from '@blueprintjs/core';
import ThemeContext from '../themecontext';
import SolutionPanel from '../solutionpanel';
import SSDContent from './ssdcontent';
import SolutionVisualizer from './solutionvisualizer';
import _ from 'lodash';

export default class SSD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
                        numOfBlocks: 8,
                        pagesPerBlock: 4,
                        minEmptyBlocks: 2,
                        referredBlocks: [],
                        content: null,
                        mostReferred: -1,
                        refPages: null,
                        error: ""
                    };
        this.checkParamValidity = this.checkParamValidity.bind(this);
        this.generateParams = this.generateParams.bind(this);
    }

    componentDidMount() {
        this.generateParams();
    }

    generateParams() {
        this.setState({
            numOfBlocks: _.random(4, 16),
            pagesPerBlock: _.sample([4,8,12]),
            content: null,
            minEmptyBlocks: 2
        }, () => this.generateContent());
    }

    checkParamValidity() {
        if (this.state.minEmptyBlocks >= this.state.numOfBlocks)
            this.setState({error: `A szabad blokkok kívánatos száma nem lehet nagyobb, vagy egyenlő a blokkok teljes számánál!`});
        else
            this.setState({error: ""});
    }

    writePage(ssd, pageIx) {

        function writeToBlock(block, page) {
            block.pages[block.nextWrPos].state = 'v';
            block.pages[block.nextWrPos].page = page;
            block.nextWrPos++;
        }

        const writeList = [ pageIx ];
        while (writeList.length > 0) {
            const toWrite = writeList.shift();

            // try to find it and set state to undefined
            ssd.blocks.forEach(blk => blk.pages.forEach(pg => {
                if (pg.state === 'v' && pg.page === toWrite)
                    pg.state = 'i';
            }));

            if (ssd.blocks[ssd.frontier].nextWrPos < this.state.pagesPerBlock) 
                writeToBlock(ssd.blocks[ssd.frontier], toWrite);
            else {
                // select new write frontier
                let minAge = Number.POSITIVE_INFINITY;                
                for (let ix=0; ix < this.state.numOfBlocks; ix++) 
                    if (ssd.blocks[ix].nextWrPos === 0 && ssd.blocks[ix].age < minAge) {
                        ssd.frontier = ix;
                        minAge = ssd.blocks[ix].age;
                    }
                
                // write the page there
                writeToBlock(ssd.blocks[ssd.frontier], toWrite);

                // check if gc is needed
                if (ssd.blocks.reduce((total, val) => total + (val.nextWrPos === 0), 0) < this.state.minEmptyBlocks) {
                    // collect blocks with the highest number of invalid pages
                    let numInvalid = 0;
                    const candidates = [];
                    for (let ix=0; ix < this.state.numOfBlocks; ix++) {
                        const inv = ssd.blocks[ix].pages.reduce((total, val) => total + (val.state === 'i'), 0);
                        if (inv > numInvalid) {
                            numInvalid = inv;
                            candidates.length = 0;
                            candidates.push(ix);
                        }
                        else if (inv === numInvalid)
                            candidates.push(ix);
                    }
                    if (numInvalid === 0)
                        console.log('GÁZ');
                    // among them, collect the youngest ones
                    const youngest = [];
                    let youngestAge = Number.POSITIVE_INFINITY;
                    for (const ix of candidates)
                        if (ssd.blocks[ix].age < youngestAge) {
                            youngestAge = ssd.blocks[ix].age;
                            youngest.length = 0;
                            youngest.push(ix);
                        }
                        else if (ssd.blocks[ix].age === youngestAge)
                            youngest.push(ix);
                    // pick a victim
                    const victim = ssd.blocks[youngest.reduce((total, val) => Math.min(total, val), this.state.numOfBlocks)];
                    // add valid pages to the list and erase everything
                    for (const pg of victim.pages) {
                        if (pg.state === 'v')
                            writeList.push(pg.page);
                        pg.state = 'e';
                        pg.page = -1;
                    }
                    victim.nextWrPos = 0;
                    victim.age++;                    
                }
            }
        }
    }

    generateContent() {

        const content = { 
            frontier: 0, 
            blocks: _.range(this.state.numOfBlocks).map(ix => ({
                age: 0,
                nextWrPos: 0,
                pages: _.range(this.state.pagesPerBlock).map(jx => ({ state: 'e', page: -1 }))
                }))
        };

        const alpha = 2;
        const numOfUsedBlocks = this.state.pagesPerBlock*this.state.numOfBlocks/2;
        const paretoDist = new Float64Array(numOfUsedBlocks);
        const cumParetoDist = new Float64Array(numOfUsedBlocks);
        let sum = 0;
        for(let i = 0; i < numOfUsedBlocks; i++) {
            paretoDist[i] = (1+i)**(-alpha);
            sum += paretoDist[i];
        }
        cumParetoDist[0] = paretoDist[0] / sum;
        for(let i = 1; i < numOfUsedBlocks; i++)
            cumParetoDist[i] = cumParetoDist[i-1] + paretoDist[i] / sum;

        const blocks = _.slice(_.shuffle(_.range(this.state.pagesPerBlock*this.state.numOfBlocks)), 0, numOfUsedBlocks);

        for(let dn = 0; dn <= 1000 || (content.blocks[content.frontier].nextWrPos < this.state.pagesPerBlock/2 || content.blocks[content.frontier].nextWrPos === this.state.pagesPerBlock); dn++) {
            //const refPage = _.random(0, this.state.pagesPerBlock*this.state.numOfBlocks/2-1);
            const p = Math.random();
            let refPageIx = 0;
            while (cumParetoDist[refPageIx] < p) 
                refPageIx++;
            this.writePage(content, blocks[refPageIx]);
        }

        const refPages = _.range(Math.max(this.state.pagesPerBlock - content.blocks[content.frontier].nextWrPos + 1, 3)).map(i => {
            const p = Math.random();
            let refPageIx = 0;
            while (cumParetoDist[refPageIx] < p) 
                refPageIx++;
            return blocks[refPageIx];
        });

        const solutions = [content];
        let prev = content;
        for(let i = 0; i < refPages.length; i++) {
            prev = _.cloneDeep(prev);
            this.writePage(prev, refPages[i]);
            solutions.push(prev);
        }

        this.setState({content: content, mostReferred: blocks[0], refPages: refPages, solutions: solutions});
    }

    static contextType = ThemeContext;

    render() {

        let useful = 0;
        if (this.state.content)
            this.state.content.blocks.forEach(blk => blk.pages.forEach(pg => {
                if (pg.state === 'v')
                    useful++;
            }));
        useful /= this.state.pagesPerBlock*this.state.numOfBlocks;

        return (            
            <> 
                <div className="title-area">
                    <h1>SSD adattárolók</h1>
                    <h2>Felépítés és tartalommenedzsment</h2>
                </div>
                <div className="demo-emph-row">
                    <div className="ssd-param-panel">
                        <h3>Paraméterek:</h3>
                        <p className="ssd-param-title">Egy SSD az alábbi paraméterekkel rendelkezik.</p>                        
                        <div className="ssd-param-grid">
                            <div className="ssd-param-label">Blokkok száma: </div>
                            <div className="ssd-param-row">
                                <NumericInput 
                                    className="ssd-param-numeric"
                                    fill="true"
                                    value={this.state.numOfBlocks}
                                    onValueChange={val => this.setState({numOfBlocks: val}, () => this.generateContent())}
                                    min={4}
                                    max={24}
                                />
                            </div>
                            <div className="ssd-param-label">Lapok száma blokkonként: </div>
                            <div className="ssd-param-row">
                                <NumericInput 
                                    className="ssd-param-numeric"
                                    fill="true"
                                    value={this.state.pagesPerBlock}
                                    onValueChange={val => this.setState({pagesPerBlock: val}, () => this.generateContent())}
                                    min={4}
                                    max={16}
                                />
                            </div>                            
                        </div>
                        <p className="ssd-param-title">Az SSD kiindulóállapota az alábbi ábrán látható. Egy táblázat egy blokkot reprezentál. 
                        A blokkok fejlécében, a bal felső sarokban (kiemelve) a sorszám, a jobb felsőben pedig #P/E jelöléssel az eddigi törlések száma (number of programming/erase cycles) látható. 
                        Az alattuk látható sorok mutatják a lapok tartalmát és állapotát. A sorok bal oldalán feltüntetett állapot lehet: </p>
                        <ul>
                            <li>"H"=használatban,</li>
                            <li>"É"=érvénytelen,</li>
                            <li>"T"=törölt.</li>
                        </ul>
                        <p>A sorok jobb oldalán, ha volt már az adott lapra írás, az a szám látható, hogy melyik LBA cím található a lapon (most tekintsünk el attól, hogy a szektorméret és a lapméret nem egyenlő).</p>                              
                        <div className="ssd-content-with-refresh">
                            <SSDContent content={this.state.content}/>
                            <Button 
                                icon="refresh" 
                                minimal="true" 
                                className="ssd-refresh-content"
                                onClick={() => this.generateContent()} 
                            />                      
                        </div>
                        <p>Az SSD-hez sorban egymás után az alábbi címekre érkezik írási kérés: <span className="ssd-request">{this.state?.refPages?.join(", ")}</span>.</p>                        
                        <Button 
                            icon="refresh"
                            text="Random generálás"
                            className="ssd-generate-button"
                            onClick={this.generateParams} 
                        />   
                    </div>
                </div>
                <div>
                    <h3>1. Feladat</h3>
                    <p> Hányas blokk lehet az írási front a kezdőállapotban? </p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">                        
                        <div className="demo-emph-row">
                            <p>Az írási frontot onnan lehet megismerni, hogy egyaránt vannak rajta használatban lévő és törölt lapok is. 
                            Ennek megfelelően a kezdőállapotban az írási front a &nbsp;<span className="demo-solution-value">{this.state.content?.frontier}</span>. blokk.</p>
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>2. Feladat</h3>
                    <p> Hányas szektor lehet a "legforróbb" (leggyakrabban írt)? </p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">                        
                        <div className="demo-emph-row">
                            <p>A leggyakrabban írt szektor a legtöbb érvénytelen állapotú lapot foglaló &nbsp;<span className="demo-solution-value">{this.state.mostReferred}</span>. szektor.</p>
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>3. Feladat</h3>
                    <p>Az SSD kezdőállapotában a tárolókapacitásának hányad része tárol hasznos adatokat?</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása"> 
                        <div className="demo-emph-row">
                            <p>A valid lapok aránya az összes laphoz képest: &nbsp;<span className="demo-solution-value">{useful}</span></p>
                       </div>
                    </SolutionPanel>
                </div>                
                <div>
                    <h3>4. Feladat</h3>
                    <p>Hogyan változik az SSD állapota a fenti írási kérések végrehajtása után? </p>
                    <p>Ha új írási frontra van szükség, az SSD válassza azt, amelyik a lehető legegyenletesebb kopáshoz vezet, 
                        ha több ilyen is van, válassza a legkisebb indexűt! Ha valamelyik ı́rási kérés teljesı́tése után a törölt 
                        blokkok száma {this.state.minEmptyBlocks} alá csökken, lefut a szemétgyűjtő algoritmus, amı́g ismét {this.state.minEmptyBlocks} törölt blokk nem lesz! 
                        A szemétgyűjtő válassza mindig a legtöbb érvénytelen lapot tartalmazó blokkot, ha több ilyen is van, 
                        akkor azok közül a legkevésbé kopottat, döntetlen esetén pedig a legkisebb indexűt. 
                        A szemétgyűjtés után az SSD folytatja az ı́rási kérések kiszolgálását.</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása"> 
                        <div className="demo-emph-row">
                        {this.state.solutions && <SolutionVisualizer 
                            refPages={this.state.refPages}
                            solutions={this.state.solutions}
                            initial={this.state.content}
                        />}
                       </div>
                    </SolutionPanel>
                </div>                
            </>            
        );
    }
}